import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendBetweenOwnAccounts = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 140,
	height: 140,
	viewBox: "0 0 140 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_6785_27939)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 70,
				cy: 70,
				r: 45,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.75 53C52.75 51.8954 53.6454 51 54.75 51H86.85C87.9546 51 88.85 51.8954 88.85 53V78.4C88.85 80.0569 87.5069 81.4 85.85 81.4H55.75C54.0931 81.4 52.75 80.0569 52.75 78.4V53Z",
			fill: "#6B7B8B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 45.1499,
			y: 56.5996,
			width: 38.1,
			height: 32.4,
			rx: 2,
			fill: "#E7ECEE",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.0205 72.3876C59.9661 72.3876 61.5434 70.8104 61.5434 68.8647C61.5434 66.9191 59.9661 65.3418 58.0205 65.3418C56.0748 65.3418 54.4976 66.9191 54.4976 68.8647C54.4976 70.8104 56.0748 72.3876 58.0205 72.3876Z",
			fill: "#EE2B2B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.6566 81.5478H52.3833C52.3833 78.0249 53.9038 74.502 58.02 74.502C62.1361 74.502 63.6566 78.0249 63.6566 81.5478Z",
			fill: "#EE2B2B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.2607 83.048H75.7607V81.548C75.7607 79.3408 75.2897 76.9865 74.0367 75.1363C72.7324 73.2103 70.6494 71.9453 67.7786 71.9453C64.9077 71.9453 62.8247 73.2103 61.5204 75.1363C60.2674 76.9865 59.7964 79.3408 59.7964 81.548V83.048H61.2964H74.2607Z",
			fill: "black",
			stroke: "#E7ECEE",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.7784 71.0148C70.0159 71.0148 71.8298 69.201 71.8298 66.9635C71.8298 64.726 70.0159 62.9121 67.7784 62.9121C65.5409 62.9121 63.7271 64.726 63.7271 66.9635C63.7271 69.201 65.5409 71.0148 67.7784 71.0148Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.5 76.5C79.425 76.5 74.5 81.425 74.5 87.5C74.5 93.575 79.425 98.5 85.5 98.5C91.575 98.5 96.5 93.575 96.5 87.5C96.5 81.425 91.575 76.5 85.5 76.5Z",
			fill: "black",
			stroke: "white",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.4044 91.2478L88.0308 91.2478L88.0308 89.0583L82.4044 89.0583L82.4044 87.3066L79.339 90.1531L82.4044 92.9995L82.4044 91.2478Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.8104 83.7522L83.1841 83.7522L83.1841 85.9417L88.8104 85.9417L88.8104 87.6934L91.8758 84.8469L88.8104 82.0005L88.8104 83.7522Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_6785_27939",
			x: 0,
			y: 0,
			width: 140,
			height: 140,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 12.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.18 0 0 0 0 0.206667 0 0 0 0 0.22 0 0 0 0.1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6785_27939"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6785_27939",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgSendBetweenOwnAccounts;
